import { SET_CREATE_IS_VISIBLE, CREATE_PROJECT, CREATE_PROJECT_ERROR } from './constants';

const defaultState = {
    isVisible: true,
    createProjectErr: null,
};

const createUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_CREATE_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };
        case CREATE_PROJECT:
            return state;
        case CREATE_PROJECT_ERROR:
            return { ...state, createProjectErr: action.createProjectErr };


        default:
            return state;
    }
};

export default createUI;



// WEBPACK FOOTER //
// ./src/containers/NewProject/reducer.js